import React from 'react';
import { BodyMediumRegular, YStack } from 'smoothie';

const IncomeSplitEndOfRules = () => {
    return (
        <YStack
            backgroundColor="$gray200"
            borderRadius={24}
            padding={16}
            alignItems="center"
            justifyContent="center"
        >
            <BodyMediumRegular color="$gray1000">
                End of rules
            </BodyMediumRegular>
        </YStack>
    );
};

export default IncomeSplitEndOfRules;
